import { useState, useEffect, useRef, memo } from "react";
import { Clock } from "lucide-react";

const fmt = (s) => `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, "0")}`;

// Owns the per-second tick so the rest of the chat page doesn't re-render every second
export const SessionTimer = memo(({ endsAt, duration, onExpire }) => {
  const calc = () => (endsAt ? Math.max(0, Math.round((endsAt - Date.now()) / 1000)) : 0);
  const [left, setLeft] = useState(calc);
  const fired = useRef(false);

  useEffect(() => {
    fired.current = false;
    setLeft(calc());
    if (!endsAt) return;
    const id = setInterval(() => {
      const v = calc();
      setLeft(v);
      if (v <= 0 && !fired.current) { fired.current = true; clearInterval(id); onExpire(); }
    }, 1000);
    return () => clearInterval(id);
  }, [endsAt]); // eslint-disable-line

  const low = left <= 30;
  const pct = duration ? Math.min(100, (left / duration) * 100) : 0;
  return (
    <>
      <div data-testid="session-timer"
        className={`flex items-center gap-2 px-4 py-2 rounded-full border transition-colors ${low ? "border-red-300 bg-red-50" : "border-amber-200 bg-amber-50"}`}>
        <Clock className={`w-4 h-4 ${low ? "text-red-500" : "text-amber-600"}`} />
        <span className={`font-bold text-lg tabular-nums w-[3.25rem] text-center ${low ? "text-red-500" : "text-amber-700"}`} style={{ fontFamily: 'Space Grotesk' }}>
          {fmt(left)}
        </span>
      </div>
      <div className="absolute left-0 right-0 bottom-0 px-4 pb-1.5">
        <div className="max-w-2xl mx-auto h-1 rounded-full bg-gray-100 overflow-hidden">
          <div className={`h-full w-full origin-left rounded-full transition-transform duration-1000 ease-linear ${low ? "bg-red-400" : "bg-gradient-to-r from-amber-400 to-amber-600"}`}
            style={{ transform: `scaleX(${pct / 100})` }} />
        </div>
      </div>
    </>
  );
});
